/**
 * Role gating helpers — single source of truth for "what can this role do?".
 * Pair with backend role enforcement in server.py.
 */

export const ROLE_SCM   = 'supply_chain_manager';
export const ROLE_SM    = 'sustainability_manager';
export const ROLE_AUDIT = 'external_viewer';

export const readUserRole = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    return u?.role || null;
  } catch { return null; }
};

const isSCM = (r) => r === ROLE_SCM;
const isSM  = (r) => r === ROLE_SM;
const isAuditor = (r) => r === ROLE_AUDIT;

export const permissions = (role) => ({
  // operational ownership
  canRegisterProduct:       isSCM(role),
  canManageNfcTag:          isSCM(role),
  canStartMonitoringSession:isSCM(role),
  canEndMonitoringSession:  isSCM(role),
  canIngestSensorReading:   isSCM(role),
  canRunManualCorrection:   isSCM(role),

  // checkpoints
  canRunAnyCheckpoint:           isSCM(role) || isSM(role),
  canRunOperationalCheckpoints:  isSCM(role),
  canRunCustomerVerification:    isSCM(role) || isSM(role),

  // sustainability + compliance authoring
  canLogSustainabilityMetric: isSCM(role) || isSM(role),
  canLogComplianceStandard:   isSCM(role) || isSM(role),

  // reporting / export — auditors are allowed
  canDownloadReports:    true,
  canOpenPublicQr:       true,

  // navigation
  showProductInsights:   !isAuditor(role),

  // read-only flag for global UI tone
  isReadOnly: isAuditor(role),
});

export default permissions;
